// SubscriptionPage.js
import React, { useState } from 'react';
import { useSubscription } from './SubscriptionContext'; // Import SubscriptionContext
import Notiflix from 'notiflix';
import { useNavigate } from 'react-router-dom';
import LaundryImage from "./laundry.jpg";
import SubscriptionCard from "./SubscriptionCard";
const SubscriptionPage = () => {
    const { subscription, isSubscribed, upgradePlan, cancelSubscription } = useSubscription();
    const [isProcessing, setIsProcessing] = useState(false);
    const navigate = useNavigate();

    const inclusions = {
        Basic: "Includes 5 washing bags per month",
        Standard: "Includes 10 washing bags per month",
        Premium: "Includes unlimited washing bags",
    };

    const processPayment = async (newPlan, amount) => {
        try {
            const yoco = new window.YocoSDK({
                publicKey: 'pk_test_ed3c54a6gOol69qa7f45',  // Replace with your YOCO public key
            });

            const result = await new Promise((resolve, reject) => {
                yoco.showPopup({
                    amountInCents: amount * 100,  // YOCO uses cents, so multiply by 100
                    currency: 'ZAR',
                    callback: function (response) {
                        if (response.error) {
                            console.error(`Error: ${response.error.message}`);
                            Notiflix.Notify.failure(response.error.message || 'Payment failed.');
                            reject(false);
                        } else {
                            resolve(response.id);
                        }
                    },
                });
            });

            if (result) {
                setIsProcessing(true);
                await upgradePlan(newPlan, amount, result);
                setIsProcessing(false);
            }
        } catch (error) {
            console.error("Error processing payment:", error);
            Notiflix.Notify.failure('Error processing payment.');
        }
    };

    const handleCancel = () => {
        Notiflix.Confirm.show(
            'Cancel Subscription',
            'Are you sure you want to cancel your subscription?',
            'Yes, Cancel',
            'No, Keep It',
            () => {
                cancelSubscription();
            },
            () => {
                Notiflix.Notify.info('Subscription cancellation aborted.');
            }
        );
    };

    return (
        <div className="container justify-content-center" style={{paddingTop:"5px"}}>
            <br /><br />
        
            <div className="row justify-content-center">
                {isSubscribed && subscription ? (
                    <>
                        <div className="col-md-4">
                            <div className="subscription-card">
                                <center>
                                    <h2>Current Plan</h2>
                                    <img className="rounded" src={LaundryImage} alt="Laundry" style={{ width: "200px" }} />
                                    <h4>{subscription.planName}</h4>
                                    <p>{inclusions[subscription.planName.split(" ")[0]]}</p>
                                    <p>R {(subscription.priceInCents / 100).toFixed(2)}</p>
                                    <button
                                        className="btn btn-danger btn-ltd"
                                        onClick={handleCancel}
                                        disabled={isProcessing}
                                        style={{ marginTop: "10px" }}
                                    >
                                        Cancel Subscription
                                    </button>
                                </center>
                            </div>
                        </div>
                        {subscription.planName === 'Basic Plan' && (
                            <>
                                <div className="col-md-4">
                                    <div className="subscription-card">
                                        <center>
                                            <h2>Upgrade</h2>
                                            <img className="rounded" src={LaundryImage} alt="Laundry" style={{ width: "200px" }} />
                                            <h4>Standard Plan</h4>
                                            <p>{inclusions.Standard}</p>
                                            <p>Price: R114.99/month</p>
                                            <button
                                                onClick={() => processPayment('Standard Plan', 114.99)}
                                                disabled={isProcessing}
                                            >
                                                Upgrade to Standard
                                            </button>
                                        </center>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="subscription-card">
                                        <center>
                                            <h2>Upgrade</h2>
                                            <img className="rounded" src={LaundryImage} alt="Laundry" style={{ width: "200px" }} />
                                            <h4>Premium Plan</h4>
                                            <p>{inclusions.Premium}</p>
                                            <p>Price: R150.99/month</p>
                                            <button
                                                onClick={() => processPayment('Premium Plan', 150.99)}
                                                disabled={isProcessing}
                                            >
                                                Upgrade to Premium
                                            </button>
                                        </center>
                                    </div>
                                </div>
								<br/>
							</>
                        )}
                        {subscription.planName === 'Standard Plan' && (
                            <div className="col-md-4">
                                <div className="subscription-card">
                                    <center>
                                        <h2>Upgrade</h2>
                                        <img className="rounded" src={LaundryImage} alt="Laundry" style={{ width: "200px" }} />
                                        <h4>Premium Plan</h4>
                                        <p>{inclusions.Premium}</p>
                                        <p>Price: R150.99/month</p>
                                        <button
                                            onClick={() => processPayment('Premium Plan', 150.99)}
                                            disabled={isProcessing}
                                        >
                                            Upgrade to Premium
                                        </button>
                                    </center>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <SubscriptionCard/>
                )}
            </div>
            <br /><br /><br /><br /><br />
        </div>
    );
};

export default SubscriptionPage;
